var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.privacy)?_c(_vm.modules.Privacy,_vm._b({tag:"component"},'component',_vm.privacy,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }